export default __webpack_public_path__ + "static/media/icon_header_logo_zh.fa54a3d1.svg";